export default "__VITE_ASSET__01c8ffe6__"